import "./contact_us.css"
import { Grid, Button } from "@mui/material"
import { makeStyles } from "@material-ui/core/styles"
import { BsFillTelephoneFill } from "react-icons/bs"
import { Typography } from "@mui/material"
import {HiMail} from "react-icons/hi"
import {MdLocationPin} from "react-icons/md"
import {AiFillClockCircle} from "react-icons/ai"
import {useMediaQuery} from "react-responsive"
import background from '../success-stories/background.png'
import React from 'react'
//1151 px 
//1142 px

const initialState = {
  name: "",
  phone: "",
  email: "",
  company: "",
  message: ""
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    backgroundColor: theme.palette.background.paper,
    maxWidth: "100%",
    borderRadius: "25px",
    minHeight: "200%",
  },
  item: {
    background: "green",
    marginLeft: "50px",
  },
  test1: {
    background: "white",
  },
  header: {
    color: "black",
  },
  contactInfo: {
    background: "#3B5441",
    borderRadius: "20px",
    width: "452px",
    height: "605px",
    marginRight: "65px",
    paddingTop: "44px",
    paddingLeft: "52px",
    whiteSpace: "break-spaces",
  },
  outerShell: {
    background: "white",
    borderRadius: "20px",
    maxWidth: "1172px",
    height: "636px",
    display: "flex",
    paddingTop: "16px",
    margin: "auto",
    paddingLeft: "15px",
    paddingBottom: "15px",
  },
  topRow: {
    marginBottom: "46px",
    marginTop: "56px",
  },
  secondRow: {
    marginBottom: "46px",
  },
  smallOuter: {
    background: "white",
    borderRadius: "20px",
    maxWidth: "482px",
    width: "auto",
    height: "636px",
    display: "flex",
    paddingTop: "15px",
    margin: "auto",
    paddingLeft: "15px",
    paddingBottom: "15px",
  },
  smallTopRow: {
    marginBottom: "23px",
  },
}))

function OuterShell() {
  const classes = useStyles()
  return (
    <Grid container className={classes.outerShell}>
      <Grid item>
        <ContactInfo />
      </Grid>
      <Grid item>
        <FormInputs />
      </Grid>
    </Grid>
  )
}

function SmallOuterShell(){
  const classes = useStyles()
  return (
    <div>
      <div className={classes.smallOuter}>
        <div>
          <SmallContactInfo/>
        </div>
      </div>
      <div style={{background: "white", 
                  margin: "auto",  
                  borderRadius: "20px", 
                  width: "482px",
                  marginTop: "30px",
                  marginBottom: "-20px",
                  padding: "15px"}}>
        <SmallFormInputs/>
      </div>
    </div>
  )
}

function SmallContactInfo(){
  const classes = useStyles()
  return (
    <div className={classes.contactInfo}>
      <h2 id="contactInfoHeader">Contact Information</h2>
      <p>
        <Typography id="typography">
          <BsFillTelephoneFill id="icon"></BsFillTelephoneFill>   (310)435-7689
        </Typography>
        <br />
        <Typography id="typography">
          <HiMail id="icon"></HiMail>   miraclemilementors@gmail.com
        </Typography>
        <br/>
        <Typography id="typography">
          <MdLocationPin id="icon"></MdLocationPin>   55 East Villa Ave. <br/>      Pasadena, CA 91103
        </Typography>
        <br/>
        <Typography id="typography">
        <AiFillClockCircle id="icon"></AiFillClockCircle>   Mon        9 am - 5 pm <br/>      Tue         9 am - 5 pm <br/>      Wed        9 am - 5 pm <br/>      Thu         9 am - 5 pm <br/>      Fri           9 am - 5 pm <br/>      Sat          Closed <br/>      Sun         Closed <br/>
        </Typography>
      </p>
    </div>
  )
}

function SmallFormInputs(){
  const classes = useStyles()
  return (
    <div style={{display: "inline-block"}}>
      <form>
        <Grid>
          <Grid className={classes.smallTopRow}>
            <div style={{ float: "left", marginRight: "32px"}}>
              <label htmlFor="name">Name*</label>
              <input
                placeholder="John Doe"
                type="text"
                name="name"
                style={{ maxWidth: "210px" }}
              ></input>
            </div>
            <div style={{ float: "right" }}>
              <label>Phone Number*</label>
              <input
                placeholder="(123)456-7890"
                style={{ maxWidth: "210px" }}
              ></input>
            </div>
            <br style={{ clear: "both" }} />
          </Grid>
          <Grid className={classes.smallTopRow}>
            <div style={{ float: "left", marginRight: "32px" }}>
              <label>Email*</label>
              <input
                placeholder="johndoe@gmail.com"
                style={{ maxWidth: "210px" }}
              ></input>
            </div>
            <div style={{ float: "right" }}>
              <label>Company Name</label>
              <input placeholder="Company" style={{ maxWidth: "210px" }}></input>
            </div>
            <br style={{ clear: "both" }} />
          </Grid>
          <Grid>
            <div style={{float: "left", marginRight: "32px"}}>
              <label>Message*</label>
              <input
                placeholder="Write your message..."
                style={{ maxWidth: "420px" }}
              ></input>
            </div>
            <div style={{float: "right"}}>
              <Button id="smallSubmitButton" type="submit">Submit</Button>
            </div>
          </Grid>
        </Grid>
      </form>
    </div>
  )
}

function FormInputs() {
  const classes = useStyles()

  interface State {
    name: string,
    phone: string,
    email: string,
    company: string,
    message: string
  }

  const [values, setValues] = React.useState<State>({
    name: "",
    phone: "",
    email: "",
    company: "",
    message: ""
  })
  const handleChange =
  (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({ ...values, [prop]: event.target.value })
  }
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    console.log(values)
    const body = {
      name: values.name,
      phone: values.phone,
      email: values.email,
      company: values.company,
      message: values.message
    }
    // alert(JSON.stringify(body)) 
    try{
      // "http://localhost:3030/api/sendContact"
      const response = await fetch("https://vercel-express-api-fotmm.vercel.app/api/sendContact", {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
       },
        body: JSON.stringify(body),
        // mode: 'no-cors'
      })
      setValues({...initialState});
      alert("Thank you for submitting the contact us form we will be reaching out shortly!");
    }
    catch (error) {
      alert(error)
      console.error(error)
      event.preventDefault()
    }
  }


  return (
    <form onSubmit={handleSubmit}>
      <Grid>
        <Grid className={classes.topRow}>
          <div style={{ float: "left", marginRight: "59px" }}>
            <label htmlFor="name">Name*</label>
            <input
              placeholder="John Doe"
              type="text"
              name="name"
              style={{ width: "276px" }}
              value={values.name}
              onChange={handleChange("name")}
            ></input>
          </div>
          <div style={{ float: "right" }}>
            <label>Phone Number*</label>
            <input
              placeholder="(123)456-7890"
              style={{ width: "275px" }}
              value={values.phone}
              onChange={handleChange("phone")}
            ></input>
          </div>
          <br style={{ clear: "both" }} />
        </Grid>
        <Grid className={classes.secondRow}>
          <div style={{ float: "left", marginRight: "59px" }}>
            <label>Email*</label>
            <input
              placeholder="johndoe@gmail.com"
              style={{ width: "276px" }}
              value={values.email}
              onChange={handleChange("email")}
            ></input>
          </div>
          <div style={{ float: "right" }}>
            <label>Company Name</label>
            <input
              placeholder="Company"
              style={{ width: "275px" }}
              value={values.company}
              onChange={handleChange("company")}
            ></input>
          </div>
          <br style={{ clear: "both" }} />
        </Grid>
        <Grid>
          <label>Message*</label>
          <input
            placeholder="Write your message..."
            style={{ width: "610px" }}
            value={values.message}
            onChange={handleChange("message")}
          ></input>
        </Grid>
        <Grid>
          <Button id="submitButton" type="submit">Submit</Button>
        </Grid>
      </Grid>
    </form>
  )
}

function ContactInfo() {
  const classes = useStyles()
  return (
    <div className={classes.contactInfo}>
      <h2 id="contactInfoHeader">Contact Information</h2>
      <p>
        <Typography id="typography">
          <BsFillTelephoneFill id="icon"></BsFillTelephoneFill>   (310)435-7689
        </Typography>
        <br />
        <Typography id="typography">
          <HiMail id="icon"></HiMail>   miraclemilementors@gmail.com
        </Typography>
        <br/>
        <Typography id="typography">
          <MdLocationPin id="icon"></MdLocationPin>   55 East Villa Ave. <br/>      Pasadena, CA 91103
        </Typography>
        <br/>
        <Typography id="typography">
        <AiFillClockCircle id="icon"></AiFillClockCircle>   Mon        9 am - 5 pm <br/>      Tue         9 am - 5 pm <br/>      Wed        9 am - 5 pm <br/>      Thu         9 am - 5 pm <br/>      Fri           9 am - 5 pm <br/>      Sat          Closed <br/>      Sun         Closed <br/>
        </Typography>
      </p>
    </div>
  )
}

function UnderBox(){
  return(
    <Grid container style={{marginBottom: "50px"}}>
      <Grid item id="whiteBox" xs={8} sm={9} md={10} lg={11} xl={12}>
        <Typography align="center" id="UnderBoxTitle" variant="h3">
          How You Can Help
        </Typography>
        <Grid id="boxText">
        <ul>
            <li>
              <Typography variant="subtitle1" id="listText">
                Please consider making a donation to Friends of the Miracle Mile.  
                Donations of any amount are graciously accepted. You can donate here via PayPal. 
              </Typography>
            </li>
            <br/>
            <li>
              <Typography variant="subtitle1" id="listText">
                Volunteer to serve on one of our committees. Considerate and thoughtful interested parties are always welcome.
              </Typography>
            </li>
            <br/>
            <li>
              <Typography variant="subtitle1" id="listText">
                Help us identify possible sources of funding for our programs.  
                Do you know a great individual or corporation that would like to invest in our community?  
              </Typography> 
            </li>
            <br/>
            <li>
              <Typography variant="subtitle1" id="listText">
                Recommend Friends of the Miracle Mile to your family and friends.
              </Typography>
            </li>
            <br/>
          </ul>
          </Grid>
      </Grid>
    </Grid>
  )
}

function Contact() {
  const classes = useStyles()
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1150px)' })
  const isNotMobile = useMediaQuery({query: '(min-width: 1151px)'})
  return (
    <div style={{justifyContent: "center", backgroundImage: `url(${background})`, marginTop: "149px"}}>
      <Typography variant="h1" id="mainHeader">Contact Us</Typography>
      <p id="shortPara">
        <Typography align="center">
        We welcome your inquiries about our programs. If you need assistance <br/> 
        with your nonprofit or have a community need that you would like us to help <br/>
        you with, please fill out our contact form and we will be in touch.
        </Typography>
      </p>
      <div>
        {isTabletOrMobile && <SmallOuterShell/>}
        {isNotMobile && <OuterShell/>}
      </div>
      <div style={{marginTop: "107px"}}>
        <UnderBox/>
      </div>
    </div>
  )
}
	
export default Contact
